var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.standardIcon ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": _vm.standardIcon.viewBox,
      "width": _vm.size,
      "height": _vm.size,
      "stroke": _vm.isFillIcon ? 'none' : `var(--${_vm.variant})`,
      "fill": _vm.isFillIcon ? `var(--${_vm.variant})` : 'none'
    }
  }, [_c('defs', [_c('mask', _vm._b({
    attrs: {
      "id": _vm.iconMaskId,
      "maskUnits": "userSpaceOnUse"
    }
  }, 'mask', _vm.standardIcon.bounds, false), _vm._l(_vm.standardIcon.paths, function (path, index) {
    return _c('path', {
      key: index,
      style: path.style,
      attrs: {
        "d": path.d
      }
    });
  }), 0)]), _c('path', {
    style: {
      strokeWidth: _vm.standardIcon.paintStrokeWidth
    },
    attrs: {
      "d": _vm.standardIcon.paintPath,
      "mask": `url(#${_vm.iconMaskId})`
    }
  })]) : _c(_vm.iconComponent, {
    tag: "component",
    attrs: {
      "viewBox": _vm.viewBox,
      "width": _vm.size,
      "height": _vm.size,
      "stroke": _vm.isFillIcon ? 'none' : `var(--${_vm.variant})`,
      "fill": _vm.isFillIcon ? `var(--${_vm.variant})` : 'none'
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };